import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import * as GrIcons from "react-icons/gr";
import { MdCheck, MdContentCopy, MdOpenInNew } from "react-icons/md";
import { useMixpanel } from "react-mixpanel-browser";
import { toast } from "react-toastify";
import { makePostRequest } from "../../../../services/apiHandler";
import CurrencyFormatter from "../../../../shared/currency-formatter";
import Loader from "../../../../shared/loader/Loader";
import { variants } from "../../../../shared/variants";
import { getTenantHost } from "../../../../../theme";
import { STANDARD_INSURANCE_DOMAIN_PREFIX } from "../../../../enums/prefix";
import { useWizard } from "react-use-wizard";
import { useDispatch, useSelector } from "react-redux";
import { stepActions } from "../../../../store/Steps";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";



function ChapaGatewayPayment({ setCurrentScreen }: any) {
    const { t } = useTranslation();
    const { previousStep } = useWizard();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const savedQuote = JSON.parse(sessionStorage.getItem("quote")!);
    const SKEY = sessionStorage.getItem("SKEY") || "";
    const quote_id = sessionStorage.getItem("quote_id");
    const tenantCreds = useSelector((state: any) => state.tenantCreds);

    const isEthiopianTenant = getTenantHost()?.includes(STANDARD_INSURANCE_DOMAIN_PREFIX);
    const phonePlaceholder = isEthiopianTenant ? "0912345678" : "+254729000000";

    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);
    const [checkoutUrl, setCheckoutUrl] = useState<string | null>(null);
    const [urlError, setUrlError] = useState<string | null>(null);
    const [copied, setCopied] = useState(false);
    const [hasCopiedUrl, setHasCopiedUrl] = useState(false);

    const mixpanel = useMixpanel();

    useEffect(() => {
        if (mixpanel.config.token) {
            mixpanel.track("PageView", {
                pageName: "Travel|Payment-gateway",
            });
        }
    }, [mixpanel]);

    const proceed = async () => {
        if (!phone) {
            toast.warning(t("chapa.phoneError"));
            document.getElementById("phoneNumber")?.focus();
            return;
        }

        setLoading(true);
        try {
            const body = {
                _id: quote_id,
                phoneNumber: phone,
                returnUrl: `${window.location.origin}/products/travel#/payments/callback?_id=${quote_id}`,
            };

            const result: IApiResponse = await makePostRequest(
                `${process.env.REACT_APP_CORE_PAYMENTS_URL}/ethiopia/chapa/initialize`,
                body,
                {
                    SKEY,
                    ModuleID: `${tenantCreds?.moduleId}`,
                    apiKey: `${tenantCreds?.moduleId}`,
                },
            );

            if (result.Status === 200) {
                const url = result.Payload?.checkout_url;
                const err = result.Payload?.error;
                if (err) {
                    setUrlError(err);
                    return;
                }
                setCheckoutUrl(url);
            } else {
                const msg: string =
                    typeof result.Payload === "string"
                        ? result.Payload
                        : t("chapa.initiateFailed");
                setUrlError(msg);
            }
        } catch (error: any) {
            console.error(error);
            setUrlError(t("chapa.initiateFailed"));
        } finally {
            setLoading(false);
        }
    };

    const previous = () => {
        dispatch(stepActions.onRemoveStep());
        previousStep();
    }

    return (
        <div className="container">
            <motion.div
                variants={variants}
                initial="enter"
                animate="center"
                exit={{ opacity: 0 }}
                className="steps-conatiner2"
            >
                <br />
                <div className="paym-confirmation-container px-2">
                    <div className="paym-confirmation-wapper">
                        <div className="paym-text">
                            {t("chapa.almostThere")} <br />
                            {t("chapa.pleasePay")}{" "}
                            <span className="paym-text-amount">
                                <CurrencyFormatter
                                    value={savedQuote?.amount.toFixed(2)}
                                    displayType={"text"}
                                    prefix
                                />
                            </span>

                        </div>
                        <div className="mt-5 mb-5">
                        </div>
                        <p className="pym-p">
                            {t("chapa.enterPhonePrompt")}{" "}
                            <span style={{ fontFamily: "Roboto", fontWeight: 400 }}>
                                {t("chapa.redirectInstruction")}
                            </span>
                        </p>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="ky-input-wrapper">
                                    <motion.div
                                        animate={{ scale: [-0.7, 1] }}
                                        transition={{ duration: 1 }}
                                        className="py-input-container mt-4"
                                    >
                                        <label className="text-left-label mb-2" htmlFor="phoneNumber">
                                            {t("chapa.phoneLabel")}
                                        </label>
                                        <br />
                                        <input
                                            id="phoneNumber"
                                            name="phoneNumber"
                                            className="mpesa-number"
                                            type="text"
                                            onChange={(e) => setPhone(e.target.value)}
                                            value={phone}
                                            placeholder={phonePlaceholder}
                                        />
                                    </motion.div>
                                </div>
                            </div>
                        </div>

                        {/* Error message */}
                        {urlError && !checkoutUrl && (
                            <div
                                className="mt-3"
                                style={{
                                    background: "#fef2f2",
                                    border: "1px solid #fca5a5",
                                    borderRadius: "8px",
                                    padding: "10px 14px",
                                    color: "#991b1b",
                                    fontSize: "13px",
                                }}
                            >
                                {urlError}
                            </div>
                        )}

                        {loading && <Loader />}
                        {!loading && !checkoutUrl && (
                            <div className="mt-5" onClick={proceed}>
                                <button className="pointer-btn">{t("chapa.confirmPayment")}</button>
                            </div>
                        )}

                        {/* Checkout URL actions */}
                        {checkoutUrl && (
                            <div className="mt-4">
                                <div className="row g-3">
                                    <div className="col-12 col-md-6">
                                        <button
                                            id="chapa-copy-url-btn"
                                            className="pointer-btn w-100"
                                            style={{ background: copied ? "#16a34a" : undefined, display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}
                                            onClick={() => {
                                                navigator.clipboard.writeText(checkoutUrl).then(() => {
                                                    setCopied(true);
                                                    setHasCopiedUrl(true);
                                                    toast.success(t("chapa.urlCopied"));
                                                    setTimeout(() => setCopied(false), 2500);
                                                }).catch(() => toast.error(t("chapa.failedToCopy")));
                                            }}
                                        >
                                            {copied ? <MdCheck size={16} /> : <MdContentCopy style={{ border: "unset !important" }} size={16} />}
                                            {copied ? t("chapa.copied") : t("chapa.copyUrl")}
                                        </button>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <button
                                            id="chapa-open-url-btn"
                                            className="pointer-btn w-100"
                                            style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}
                                            onClick={() => {
                                                window.open(checkoutUrl, "_blank", "noopener,noreferrer");
                                                setHasCopiedUrl(true);
                                            }}
                                        >
                                            <MdOpenInNew size={16} style={{ border: "unset !important" }} />
                                            {t("chapa.openUrl")}
                                        </button>
                                    </div>
                                </div>
                                {hasCopiedUrl && (
                                    <div className="mt-4 p-4 text-center shadow-1" style={{
                                        background: "var(--quote-background-color)",
                                        border: "1px solid var(--primary-color)",
                                        borderRadius: "14px",
                                    }}>
                                        <p style={{ fontSize: "0.9rem", color: "var(--secondary-color)", opacity: 0.9, lineHeight: 1.6, marginBottom: "16px", fontWeight: 500 }}>
                                            {t("chapa.shareVerifyPrompt", "Successfully generated the payment checkout link! You can copy and share it with the person paying. Once shared, click below to verify.")}
                                        </p>
                                        <button
                                            id="chapa-verify-manually-btn"
                                            className="pointer-btn w-100"
                                            style={{
                                                maxWidth: "340px",
                                                margin: "0 auto",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                            onClick={() => {
                                                navigate(`/payments/callback?_id=${quote_id}`);
                                            }}
                                        >
                                            {t("chapa.verifyPaymentStatus", "Verify Payment Status")}
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-5">
                        <div className="previous">
                            <span
                                onClick={previous}
                            >
                                <span className="GrIcon me-2">
                                    <GrIcons.GrFormPreviousLink />
                                </span>{" "}
                                <span className="previous">{t("chapa.previous")}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <br />
                <br />
            </motion.div>
        </div>
    );
}

export default ChapaGatewayPayment;